import { formatCnpj } from './federal-tax-id'

const regexCNPJ = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/

function matchNumbers(value: string | number | number[]) {
  if (typeof value === 'string') {
    return (value.match(/\d/g) || []).map(Number)
  } else if (typeof value === 'number') {
    return value.toString().match(/\d/g)?.map(Number) || []
  } else if (Array.isArray(value)) {
    return value.filter((v) => typeof v === 'number' && v >= 0 && v <= 9)
  }
  return []
}

function validCalc(length: number, numbers: number[]) {
  const weights = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  let sum = 0
  for (let i = 0; i < length; i++) {
    sum += numbers[i] * weights[weights.length - length + i]
  }
  const remainder = sum % 11
  return remainder < 2 ? 0 : 11 - remainder
}

export function isValidCNPJ(value: string | number | number[] = '') {
  if (!value) return false

  const isString = typeof value === 'string'
  const validTypes = isString || Number.isInteger(value) || Array.isArray(value)

  if (!validTypes) return false

  const numbers = matchNumbers(value)

  if (numbers.length !== 14) return false

  const items = [...new Set(numbers)]
  if (items.length === 1) return false

  const digits = numbers.slice(12)

  const digit0 = validCalc(12, numbers)
  if (digit0 !== digits[0]) return false

  const digit1 = validCalc(13, numbers)
  return digit1 === digits[1]
}

/**
 * Mantida pela assinatura antiga. Delega para `formatCnpj`
 * (`utils/federal-tax-id`): 14 dígitos formatados, o resto como veio.
 * `validate` não tem mais efeito: devolver `xx.xxx.xxx/xxxx-xx` escondia o
 * dado e cortar o 15º dígito mostrava outro CNPJ. Para validar, use `isValidCNPJ`.
 */
export function formatCNPJ(value: string | number | number[] | null = '', _validate: boolean = true) {
  return formatCnpj(Array.isArray(value) ? value.join('') : value)
}
